/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { RestoreInstanceVolumeInput } from '../models/RestoreInstanceVolumeInput';

export class AwsEc2InstanceRestoreTarget {
  /**
  * Region to restore the instance to.
  */
  'region': string;
  /**
  * Instance type to use for the restored instance.
  */
  'instanceType': string;
  /**
  * Subnet ID to associate with the restored instance.
  */
  'subnetId': string;
  /**
  * List of security group IDs to associate with the restored instance.
  */
  'securityGroupIds'?: Array<string>;
  /**
  * Tags to apply to the restored instance as key-value pairs, where key and value are both strings.  **Example:** `{\"eon_api_restore\": \"true\"}` 
  */
  'tags'?: { [key: string]: string; };
  /**
  * Volumes to restore and attach to the restored instance. Each item in the list corresponds to a volume to be restored, where `providerVolumeId` matches the volume\'s ID at the time of the snapshot. The root volume must be present in the list. 
  */
  'volumeRestoreParameters': Array<RestoreInstanceVolumeInput>;
  /**
  * Optional instance profile name to apply to the output instance
  */
  'instanceProfileName'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "region",
      "baseName": "region",
      "type": "string",
      "format": ""
    },
    {
      "name": "instanceType",
      "baseName": "instanceType",
      "type": "string",
      "format": ""
    },
    {
      "name": "subnetId",
      "baseName": "subnetId",
      "type": "string",
      "format": ""
    },
    {
      "name": "securityGroupIds",
      "baseName": "securityGroupIds",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "tags",
      "baseName": "tags",
      "type": "{ [key: string]: string; }",
      "format": ""
    },
    {
      "name": "volumeRestoreParameters",
      "baseName": "volumeRestoreParameters",
      "type": "Array<RestoreInstanceVolumeInput>",
      "format": ""
    },
    {
      "name": "instanceProfileName",
      "baseName": "instanceProfileName",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AwsEc2InstanceRestoreTarget.attributeTypeMap;
  }

  public constructor() {
  }
}

